export enum ClaimantInformationFormLabelsEnum {
  TITLE = 'Claimant',
  CLEAR = 'Clear',
  MATCH = 'Match',
}
